import { createSlice } from '@reduxjs/toolkit';

export const SlaSlice = createSlice({
    name: 'sla',
    initialState: {
        sla_list: [],
        sla: {},
        alert_risk_levels: [],
        alert_risk_levels_actions_select: [],
        critical_words: [],

    },
    reducers: {
        setSlaRedux: (state, { payload }) => {
            state.sla_list = payload;
        },
        storeSlaRedux: (state, { payload }) => {
            state.sla = payload;
        },
        setAlertRiskLevelsRedux: (state, { payload }) => {
            state.alert_risk_levels = payload;
        },
        setAlertRiskLevelsActionsSelectRedux: (state, { payload }) => {
            state.alert_risk_levels_actions_select = payload;
        },
        setCriticalWordsRedux: (state, { payload }) => {
            state.critical_words = payload;
        }
    }
});

// Action creators are generated for each case reducer function
export const { setSlaRedux, storeSlaRedux, setAlertRiskLevelsRedux,
    setAlertRiskLevelsActionsSelectRedux, setCriticalWordsRedux } = SlaSlice.actions;
